import { useEmbedMode } from './embed-mode-provider';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var ErrorSuppressor = function ErrorSuppressor(_ref) {
  var children = _ref.children;

  var _useEmbedMode = useEmbedMode(),
      suppressErrors = _useEmbedMode.suppressErrors;

  return suppressErrors ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};